// Quick View Modal Handler
(function() {
  'use strict';

  function initQuickView() {
    // Handle quick view button clicks
    document.addEventListener('click', function(e) {
      const quickViewBtn = e.target.closest('.btn_view_quick');
      
      if (quickViewBtn) {
        e.preventDefault();
        e.stopPropagation();
        
        // Find the modal within the same card wrapper
        const cardWrapper = quickViewBtn.closest('.card-wrapper');
        if (cardWrapper) {
          const modal = cardWrapper.querySelector('.quickViewModal');
          if (modal) {
            // Store original parent if not already stored
            if (!modal.dataset.originalParent) {
              modal.dataset.originalParent = 'true';
              // Store reference to original parent element
              modal._originalParent = modal.parentNode;
            }
            
            // Move modal to body if not already there
            if (modal.parentNode !== document.body) {
              document.body.appendChild(modal);
            }
            
            // Open the modal
            modal.classList.add('enableQuickView');
            document.body.style.overflow = 'hidden';
          }
        }
      }
      
      // Handle close button clicks
      const closeBtn = e.target.closest('.close_quickView, .qv__close, .qv__close-icon');
      if (closeBtn) {
        e.preventDefault();
        e.stopPropagation();
        
        // Find the modal
        const modal = closeBtn.closest('.quickViewModal');
        if (modal) {
          // Close the modal
          modal.classList.remove('enableQuickView');
          document.body.style.overflow = '';
          
          // Move modal back to original parent if it exists
          if (modal._originalParent && modal.parentNode === document.body) {
            modal._originalParent.appendChild(modal);
          }
        }
      }
      
      // Close modal when clicking on overlay (background)
      if (e.target.classList.contains('quickViewModal') && e.target.classList.contains('enableQuickView')) {
        const modal = e.target;
        modal.classList.remove('enableQuickView');
        document.body.style.overflow = '';
        
        // Move modal back to original parent if it exists
        if (modal._originalParent && modal.parentNode === document.body) {
          modal._originalParent.appendChild(modal);
        }
      }
      
      // Handle add to cart button in quick view modal
      const addToCartBtn = e.target.closest('.triggeraddon');
      if (addToCartBtn) {
        e.preventDefault();
        e.stopPropagation();
        
        // Find the modal
        const modal = addToCartBtn.closest('.quickViewModal');
        if (!modal) return;
        
        // Get card wrapper from original parent
        // The modal was originally inside card-wrapper, so _originalParent should be card-wrapper
        let cardWrapper = null;
        if (modal._originalParent) {
          // Check if original parent is the card-wrapper
          if (modal._originalParent.classList && modal._originalParent.classList.contains('card-wrapper')) {
            cardWrapper = modal._originalParent;
          } else {
            // Otherwise, find the card-wrapper by traversing up from original parent
            cardWrapper = modal._originalParent.closest('.card-wrapper');
          }
        }
        
        // Fallback: try to find card-wrapper by matching product image or title
        if (!cardWrapper) {
          const modalImage = modal.querySelector('.modal-image-container img');
          if (modalImage && modalImage.src) {
            // Find card-wrapper that contains an image with matching src
            const allCardWrappers = document.querySelectorAll('.card-wrapper');
            for (let wrapper of allCardWrappers) {
              const wrapperImg = wrapper.querySelector('img[src*="' + modalImage.src.split('/').pop().split('?')[0] + '"]');
              if (wrapperImg) {
                cardWrapper = wrapper;
                break;
              }
            }
          }
        }
        
        if (!cardWrapper) {
          console.error('Card wrapper not found for add to cart');
          return;
        }
        
        // Get variant ID from checkbox
        const checkbox = cardWrapper.querySelector('.addons_handle input[type="checkbox"][name="id[]"]');
        if (!checkbox) {
          console.error('Checkbox not found in card wrapper');
          return;
        }
        
        const variantId = checkbox.value;
        if (!variantId) return;
        
        // Get quantity from quantity input in modal
        const quantityInput = modal.querySelector('.addoninput, .quantity__input');
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
        
        // Show loading state
        const buttonSpan = addToCartBtn.querySelector('span');
        const spinner = addToCartBtn.querySelector('.loading-overlay__spinner');
        const originalButtonText = buttonSpan ? buttonSpan.textContent : 'Add to cart';
        if (buttonSpan) buttonSpan.textContent = 'Adding...';
        if (spinner) spinner.classList.remove('hidden');
        addToCartBtn.disabled = true;
        
        // Get cart notification element
        const cartNotification = document.querySelector('cart-notification');
        if (!cartNotification) {
          console.error('Cart notification not found');
          if (buttonSpan) buttonSpan.textContent = 'Add';
          if (spinner) spinner.classList.add('hidden');
          addToCartBtn.disabled = false;
          return;
        }
        
        // Prepare form data (same as normal add to cart)
        const formData = new FormData();
        formData.append('id[]', variantId);
        formData.append('quantity', quantity);
        
        // Add sections to get updated cart HTML (exact same format as product-form.js)
        if (typeof cartNotification.getSectionsToRender === 'function') {
          formData.append('sections', cartNotification.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }
        
        // Add to cart using same method as normal add to cart
        // Use fetchConfig if available, otherwise use manual config
        let config;
        if (typeof fetchConfig === 'function') {
          config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          // Remove Content-Type header - browser will set it with boundary for FormData
          delete config.headers['Content-Type'];
          config.body = formData;
        } else {
          config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
              // Don't set Content-Type - browser will set it automatically for FormData
            },
            body: formData
          };
        }
        
        fetch(window.routes?.cart_add_url || '/cart/add.js', config)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(response => {
          if (response.status) {
            // Error response
            console.error('Cart add error:', response);
            alert(response.description || 'Failed to add product to cart. Please try again.');
            if (buttonSpan) buttonSpan.textContent = originalButtonText;
            if (spinner) spinner.classList.add('hidden');
            addToCartBtn.disabled = false;
            return;
          }
          
          // Success - DO NOT check the checkbox or update icon state
          // The checkbox is only for the main product's add to cart flow
          // Adding from quick view should not affect the checkbox state
          
          // Render cart contents and open side cart (same as normal add to cart)
          if (typeof cartNotification.renderContents === 'function') {
            cartNotification.renderContents(response);
            cartNotification.classList.remove('is-empty');
          }
          
          // Close quick view modal
          modal.classList.remove('enableQuickView');
          document.body.style.overflow = '';
          
          // Move modal back to original parent if it exists
          if (modal._originalParent && modal.parentNode === document.body) {
            modal._originalParent.appendChild(modal);
          }
          
          // Reset button state
          if (buttonSpan) buttonSpan.textContent = originalButtonText;
          if (spinner) spinner.classList.add('hidden');
          addToCartBtn.disabled = false;
          
          // Run custom offers if available
          if (window.CUSTOM_OFFERS && typeof window.CUSTOM_OFFERS.runCustomOffers === 'function') {
            window.CUSTOM_OFFERS.runCustomOffers();
          }
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          console.error('Variant ID:', variantId);
          console.error('Quantity:', quantity);
          
          // Reset button state on error
          if (buttonSpan) buttonSpan.textContent = originalButtonText;
          if (spinner) spinner.classList.add('hidden');
          addToCartBtn.disabled = false;
          
          // Show error message
          alert('Failed to add product to cart. Please try again.');
        });
      }
    });
    
    // Close modal on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        const openModal = document.querySelector('.quickViewModal.enableQuickView');
        if (openModal) {
          openModal.classList.remove('enableQuickView');
          document.body.style.overflow = '';
          
          // Move modal back to original parent if it exists
          if (openModal._originalParent && openModal.parentNode === document.body) {
            openModal._originalParent.appendChild(openModal);
          }
        }
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickView);
  } else {
    initQuickView();
  }
})();

